module.exports = require("@datacamp/base-plugin");